export default class CheckStatus {
    static get New () { return 'new' }
    static get Repeat () { return 'repeat' }
    static get Send () { return 'send' }
    static get Unknown () { return 'unknown' }
    static get CommandCreated () { return 'command_created' }
    static get Complete () { return 'complete' }
    static get Fail () { return 'fail' }
    static get CancelByTimeout () { return 'timeout' }
    static get Cancel () { return 'cancel' }

    static getName (enumValue) {
      switch (enumValue) {
        case this.New:
          return 'Новый'
        case this.Repeat:
          return 'Повтор'
        case this.CommandCreated:
          return 'Команда создана'
        case this.Send:
          return 'Отправлен'
        case this.Unknown:
          return 'Результат неизвестен'
        case this.Complete:
          return 'Успешно'
        case this.Fail:
          return 'Ошибка'
        case this.CancelByTimeout:
          return 'Отменен (по таймауту)'
        case this.Cancel:
          return 'Отменен'
        default:
          return enumValue
      }
    }

    static getAllVariants () {
      const variants = [
        this.New,
        this.Repeat,
        this.Send,
        this.Unknown,
        this.Complete,
        this.Fail,
        this.CancelByTimeout,
        this.Cancel,
      ]

      return variants.map(item => ({
        value: item,
        name: this.getName(item),
      }))
    }
  }
